'use client'

import { CollectionContainer } from '@/components/common/collection/collection-container'
import CompanyCulture from './company-culture'
import EnvironmentalResponsibility from './environmental-responsibility'
import InnovativeMaterials from './innovative-materials'
import SocialResponsibility from './social-responsibility'
import SustainabilityFocus from './sustainability-focus'

export default function CommitmentList() {
  return (
    <CollectionContainer className='mx-auto max-w-screen-2xl space-y-16'>
      <EnvironmentalResponsibility />
      <SocialResponsibility />
      <InnovativeMaterials />
      <CompanyCulture />
      <SustainabilityFocus />
    </CollectionContainer>
  )
}
